import { api } from "../../lib";

export interface SourceSubsite {
  id: string;
  name: string;
  description: string | null;
  sourceId: string;
  positionX: number | null;
  positionY: number | null;
  isActive: boolean;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
  source?: { id: string; name: string } | null;
}

export interface CreateSourceSubsiteData {
  name: string;
  description?: string;
  sourceId: string;
}

export interface UpdateSourceSubsiteData
  extends Partial<CreateSourceSubsiteData> {
  id: string;
  isActive?: boolean;
}

export const sourceSubsitesService = {
  getAll: async () => {
    return api.get<SourceSubsite[]>("/admin/source-subsites");
  },

  getById: async (id: string) => {
    return api.get<SourceSubsite>(`/admin/source-subsites/${id}`);
  },

  getBySourceId: async (sourceId: string) => {
    return api.get<SourceSubsite[]>(`/admin/sources/${sourceId}/subsites`);
  },

  create: async (data: CreateSourceSubsiteData) => {
    return api.post<SourceSubsite>("/admin/source-subsites", data);
  },

  update: async ({ id, ...data }: UpdateSourceSubsiteData) => {
    return api.put<SourceSubsite>(`/admin/source-subsites/${id}`, data);
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.put<SourceSubsite>(`/admin/source-subsites/${id}`, {
      isActive,
    });
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/source-subsites/${id}`);
  },
};
